const options = {
	container: 'import-sheet',
	title: '测试Excel', // 表 头名
	lang: 'zh', // 中文
	showtoolbar: true, // 是否显示工具栏
	// devicePixelRatio: 8,
	zoomRatio: 1,
	autoFormatw: false,
	data: [{
		name: 'Sheet1', //工作表名称
	}],
  column: 0,
  row: 60,
  defaultColWidth: 200,
  defaultRowHeight: 28,
	showtoolbarConfig: {
		currencyFormat: true, //货币格式
		percentageFormat: true, //百分比格式
		numberDecrease: true, // '减少小数位数'
		numberIncrease: true, // '增加小数位数
		moreFormats: true, // '更多格式'
		link: false, // '插入链接'
		chart: false, // '图表'（图标隐藏，但是如果配置了chart插件，右击仍然可以新建图表）
		postil:  false, //'批注'
		pivotTable: false,  //'数据透视表'
		function: true, // '公式'
		frozenMode: false, // '冻结方式'
		sortAndFilter: false, // '排序和筛选'
		conditionalFormat: false, // '条件格式'
		dataVerification: true, // '数据验证'
		splitColumn: false, // '分列'
		screenshot: false, // '截图'
		findAndReplace: false, // '查找替换'
		protection:false, // '工作表保护'
		print:false,
	},
	showstatisticBar: false,
	showstatisticBarConfig: {
		count: false, // 计数栏
		view: false, // 打印视图
		zoom: true, // 缩放
	},
	cellRightClickConfig: {
		matrix: false, // 矩阵操作选区
		sort: false, // 排序选区
		filter: false, // 筛选选区
		chart: false, // 图表生成
		link: false, // 插入链接 
		data: false, // 数据验证
		cellFormat: true, // 设置单元格格式
		deleteCell: false, // 删除单元格
		rowHeight: true, // 行高
		columnWidth: true, // 列宽
		insertColumn: false, // 插入列
		deleteColumn: false, // 删除选中列
	},
	showinfobar: false, // 是否显示顶部信息栏
	showsheetbar: false, // 是否显示底部sheet按钮
	sheetFormulaBar: true, // 是否显示公式栏
}

export default options